export default __webpack_public_path__ + "static/media/anim.b9715c53.mp4";